// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9 2H1V21H2C4.94416 21 7.13918 21.2453 8.5856 21.4864C9.30891 21.6069 9.84535 21.7265 10.195 21.8139C10.3698 21.8576 10.4979 21.8933 10.5794 21.917C10.6201 21.9289 10.6492 21.9378 10.6666 21.9432L10.6838 21.9487L10.6847 21.949L10.686 21.9494L10.8377 22H13.1623L13.314 21.9494L13.3162 21.9487L13.3334 21.9432C13.3508 21.9378 13.3799 21.9289 13.4206 21.917C13.5021 21.8933 13.6302 21.8576 13.805 21.8139C14.1546 21.7265 14.6911 21.6069 15.4144 21.4864C16.8608 21.2453 19.0558 21 22 21H23L23 2H15C13.8053 2 12.7329 2.52376 12 3.35418C11.2671 2.52375 10.1947 2 9 2ZM3 19.0093V4H9C10.1046 4 11 4.89543 11 6V19.9575C10.9117 19.9332 10.805 19.9049 10.68 19.8736C10.2796 19.7735 9.69108 19.6431 8.9144 19.5136C7.53509 19.2837 5.56349 19.0572 3 19.0093ZM19 10H15V8H19V10ZM19 13H15V11H19V13Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-book-open-filled')
export default class BookOpenFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'book-open-filled',
    }
  }
}
